/* eslint-disable */

// SEE-1042 — QuickBooks Desktop (QBD) direct connect flow.
//
// These operations live on the CDK AppSync API (JWT auth via cdkGraphqlRequest),
// NOT Amplify AppSync — the same endpoint the QBO direct-connect flow uses.
// Backend contract: speedchain-cdk/graphql/07-qbwc-connection.graphql (SEE-1039),
// handled by src/functions/qbwc-connection/index.py. Frontend-only story —
// do not add these to the generated src/graphql/* files.

export const qbwcConnectionCreate = /* GraphQL */ `
  mutation QbwcConnectionCreate($paidolId: ID!) {
    qbwcConnectionCreate(paidolId: $paidolId) {
      connectionId
      qbwcUsername
      oneTimePassword
      qwcFileContent
    }
  }
`;

export const getQbwcConnection = /* GraphQL */ `
  query GetQbwcConnection($paidolId: ID!) {
    getQbwcConnection(paidolId: $paidolId) {
      connectionId
      enabled
      lastSyncAt
      syncStartedAt
      syncEndedAt
      lastSyncOk
      companyFile
      lastResults {
        name
        ok
        detail
      }
    }
  }
`;

export const qbwcConnectionSetEnabled = /* GraphQL */ `
  mutation QbwcConnectionSetEnabled($paidolId: ID!, $enabled: Boolean!) {
    qbwcConnectionSetEnabled(paidolId: $paidolId, enabled: $enabled) {
      connectionId
      enabled
    }
  }
`;

export const qbwcConnectionDelete = /* GraphQL */ `
  mutation QbwcConnectionDelete($paidolId: ID!) {
    qbwcConnectionDelete(paidolId: $paidolId) {
      connectionId
      deleted
    }
  }
`;
